import { styled } from '@raskrask-dk/rr-components'

export const Divider = styled('div', {
    bgc: '$primary400',
    height: 1,
    width: '100%',
})

export const StyledCheckout = styled('div', {
    br: '$2',
    margin: '0px auto',
    maxW: 450,

    '@mobile': {
        pb: 70,
    },

    '@desktop': {
        py: '$4',
    },
})
